export default "__VITE_ASSET__CUqmdMM___"